import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IconeTituloContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getIconeTitulo(id: string): Observable<any> {
    return this.getIconeTituloContents(id).pipe(
      map(res => this.buildResponseIconeTituloObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryIconeTituloContents[0].flatData;
  }

  private getIconeTituloContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryIconeTituloContents(filter: "id eq '${id}'") {
          flatData {
            nome
            icone {
              url
            }
            titulo
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseIconeTituloObject(data: any) {
    return {
      icon: data.icone && data.icone[0]
          ? data.icone[0].url
          : null,
      highlightText: data.titulo ? data.titulo : null,
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }

}
